module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assign_order"
  }, [_c('div', {
    staticClass: "assign_form"
  }, [_c('div', {
    staticClass: "input-group select2-plugin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idUsuario),
      expression: "idUsuario"
    }],
    ref: "slUsuarios",
    staticClass: "form-control select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Buscar por nombre",
      "data-select2-container": "select-sm"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.idUsuario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.usuariosCombo), function(user) {
    return [(user.tienePedido) ? _c('option', {
      key: user._id,
      attrs: {
        "disabled": "disabled",
        "tienePedido": user.tienePedido
      },
      domProps: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.displayName))]) : _c('option', {
      key: user._id,
      attrs: {
        "tienePedido": user.tienePedido
      },
      domProps: {
        "value": user._id
      }
    }, [_vm._v(_vm._s(user.displayName))])]
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.asignarPlato($event)
      }
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default assign_trigger",
    attrs: {
      "href": "#",
      "data-toggle": "tooltip",
      "rel": "tooltip",
      "data-placement": "top",
      "data-original-title": "Asignar personas a este plato"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a087ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pedido/ComboAsignarPlato.vue
// module id = 1115
// module chunks = 5